import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: `
    input[type="text"]:not([readonly]):not([disabled]),
    input:not([type]):not([readonly]):not([disabled]),
    input[type="email"]:not([readonly]):not([disabled]),
    input[type="tel"]:not([readonly]):not([disabled]),
    textarea:not([readonly]):not([disabled])
  `,
  standalone: true,
})
export class TrimValueDirective {
  constructor(@Optional() private readonly ngControl: NgControl) {}

  @HostListener('blur')
  onBlur(): void {
    const ctrl = this.ngControl?.control;
    if (!ctrl) return;
    const value = ctrl.value;
    if (typeof value === 'string') {
      ctrl.setValue(value.trim(), { emitEvent: true });
    }
  }
}
